import * as React from "react";

import { UserProjectsContainer } from "../containers/UserProjectsContainer";
import PageContents from "../components/layouts/PageContents";

const AdminProjectsPage: React.FC = () => {
    const [title, setTitle] = React.useState("Your projects");
    const [subtitle, setSubtitle] = React.useState(
        "Please wait while we retrieve your projects..."
    );
    const [isForbidden, setIsForbidden] = React.useState(false);

    return (
        <PageContents
            title={title}
            subtitle={subtitle}
            isForbidden={isForbidden}
            variant="small"
        >
            <UserProjectsContainer
                setTitle={setTitle}
                setSubtitle={setSubtitle}
                setIsForbidden={setIsForbidden}
            />
        </PageContents>
    );
};

export default AdminProjectsPage;
